import { render, staticRenderFns } from "./EmpresaValores.vue?vue&type=template&id=77e97b63&scoped=true"
import script from "./EmpresaValores.vue?vue&type=script&lang=js"
export * from "./EmpresaValores.vue?vue&type=script&lang=js"
import style0 from "./EmpresaValores.vue?vue&type=style&index=0&id=77e97b63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e97b63",
  null
  
)

export default component.exports